import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiDeactivatePrioShare } from '../../../api';

interface DeactivatePrioShareParams {
  prioShareId: string;
  projectExtensionId: string;
}

export function useDeactivatePrioShare() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: DeactivatePrioShareParams) => {
      return apiDeactivatePrioShare(
        params.projectExtensionId,
        params.prioShareId
      );
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['prioShares', variables.projectExtensionId],
      });
    },
  });
}
